import type { FieldErrors } from 'react-hook-form';
import { fieldRoot, sectionNumber, sectionOfField, type FieldIssue } from './configurationSections';
import type { PricingConfigurationFormValues } from './pricingConfigurationSchema';

const LIST_ITEM: Record<string, string> = {
  publicationWindows: 'Fenster',
  minimumStayLeadTimeTiers: 'Stufe',
};

/** Alle Meldungen des Formulars, auch in Listen (Fenster, Stufen), in Abschnittsreihenfolge. */
export function clientIssues(
  errors: FieldErrors<PricingConfigurationFormValues>,
  text: (message: string) => string,
): FieldIssue[] {
  const found: FieldIssue[] = [];
  const walk = (node: unknown, path: string) => {
    if (!node || typeof node !== 'object') return;
    const message = (node as { message?: unknown }).message;
    if (typeof message === 'string' && message) {
      const item = /\.(\d+)(\.|$)/.exec(path);
      const prefix = item
        ? `${LIST_ITEM[fieldRoot(path)] ?? 'Eintrag'} ${Number(item[1]) + 1}: `
        : '';
      found.push({
        field: fieldRoot(path),
        section: sectionOfField(path),
        message: prefix + text(message),
        source: 'client',
      });
      return;
    }
    for (const [key, child] of Object.entries(node)) {
      if (key !== 'ref' && key !== 'type' && key !== 'types')
        walk(child, path ? `${path}.${key}` : key);
    }
  };
  walk(errors, '');
  const unique = found.filter(
    (issue, index) =>
      found.findIndex((other) => other.field === issue.field && other.message === issue.message) ===
      index,
  );
  return unique.sort((a, b) => sectionNumber(a.section) - sectionNumber(b.section));
}
